import { BaseSection, SectionTab, SectionType, TabbedSection } from '../../../types';
import { SectionFactory, SectionOptions } from './base';

export type TabbedSectionOptions = {
  tabs: SectionTab[];
  activeTab: string;
  options?: SectionOptions;
};

export class TabbedSectionFactory extends SectionFactory {
  tabs: SectionTab[];
  activeTab: string;

  constructor(options: TabbedSectionOptions) {
    super(options.options);
    this.tabs = options.tabs;
    this.activeTab = options.activeTab;
  }

  __build(base: BaseSection): TabbedSection {
    return {
      ...base,
      type: SectionType.tabbed,
      tabs: this.tabs.map(tab => ({
        name: tab.name,
        label: tab.label,
        path: tab.path,
      })),
      activeTab: this.activeTab,
    };
  }
}
